import React, { Suspense } from 'react';
import iconHabr from '../assets/icon_habr.png';

const AuthModals = React.lazy(() => import('./AuthModals'));

/* ============================ Icons (line, currentColor) ============================ */
const svg = (children, size = 24) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
);
const IconGlobe = ({ size }) => svg(<><circle cx="12" cy="12" r="9" /><path d="M3 12h18" /><path d="M12 3c2.5 2.8 4 6 4 9s-1.5 6.2-4 9c-2.5-2.8-4-6-4-9s1.5-6.2 4-9Z" /></>, size);
const IconLock = ({ size }) => svg(<><rect x="4.5" y="10" width="15" height="10" rx="2.5" /><path d="M8 10V8a4 4 0 0 1 8 0v2" /><path d="M12 14v2.5" /></>, size);
const IconDns = ({ size }) => svg(<><rect x="4" y="4" width="16" height="6" rx="1.5" /><rect x="4" y="14" width="16" height="6" rx="1.5" /><path d="M8 7h.01M8 17h.01" /></>, size);
const IconPing = ({ size }) => svg(<path d="M3 12h4l2.5 7 5-14L17 12h4" />, size);
const IconClock = ({ size }) => svg(<><circle cx="12" cy="12" r="9" /><path d="M12 7.5V12l3 2" /></>, size);
const IconBot = ({ size }) => svg(<><rect x="4.5" y="8" width="15" height="11" rx="3" /><path d="M12 4.5V8" /><circle cx="12" cy="4" r="0.6" /><path d="M9.5 13h.01M14.5 13h.01" /><path d="M10 16.2c1.2.7 2.8.7 4 0" /></>, size);
const IconRobots = ({ size }) => svg(<><path d="M6 3.5h8l4 4V20a.5.5 0 0 1-.5.5h-11A.5.5 0 0 1 6 20V4a.5.5 0 0 1 .5-.5Z" /><path d="M14 3.5V8h4" /><path d="M9 12.5h6M9 16h4" /></>, size);
const IconBell = ({ size }) => svg(<><path d="M18 16V11a6 6 0 1 0-12 0v5l-2 2h16l-2-2Z" /><path d="M9.5 18a2.5 2.5 0 0 0 5 0" /></>, size);
const IconHistory = ({ size }) => svg(<><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 4v4h4" /><path d="M12 8v4l3 2" /></>, size);
const IconChart = ({ size }) => svg(<><path d="M4 20h16" /><path d="M6 16v-4M11 16V7M16 16v-6" /></>, size);
const IconShield = ({ size }) => svg(<path d="M12 3l7 3v5c0 5-3.5 9-7 10-3.5-1-7-5-7-10V6l7-3Z" />, size);
const IconCheck = ({ size }) => svg(<path d="M5 12.5l4.5 4.5L19 7" />, size);
const IconArrow = ({ size = 16 }) => svg(<><path d="M5 12h14" /><path d="M13 6l6 6-6 6" /></>, size);
const IconChevron = ({ size = 20 }) => svg(<path d="M6 9l6 6 6-6" />, size);
const IconRocket = ({ size }) => svg(<><path d="M5 15c-1 1-1.5 4-1.5 4s3-.5 4-1.5" /><path d="M9 15l-3-3c1-5 5-9 11-9 0 6-4 10-9 11l-3-3 4-1" /><circle cx="14.5" cy="9.5" r="1.3" /></>, size);
const IconSliders = ({ size }) => svg(<><path d="M5 8h9M18 8h1M5 16h1M10 16h9" /><circle cx="16" cy="8" r="2" /><circle cx="8" cy="16" r="2" /></>, size);
const IconCart = ({ size }) => svg(<><path d="M3 4h2l2 12h11l2-8H7" /><circle cx="9" cy="20" r="1.4" /><circle cx="17" cy="20" r="1.4" /></>, size);
const IconServer = ({ size }) => svg(<><rect x="3" y="4" width="18" height="7" rx="2" /><rect x="3" y="13" width="18" height="7" rx="2" /><path d="M7 7.5h.01M7 16.5h.01" /></>, size);
const IconCode = ({ size }) => svg(<><path d="M9 8l-4 4 4 4M15 8l4 4-4 4" /></>, size);
const IconBriefcase = ({ size }) => svg(<><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18" /></>, size);
const IconInbox = ({ size }) => svg(<><path d="M4 13l2-8h12l2 8v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-5Z" /><path d="M4 13h4l1 2h6l1-2h4" /></>, size);
const IconUsers = ({ size }) => svg(<><circle cx="9" cy="8" r="3" /><path d="M3 19a6 6 0 0 1 12 0" /><path d="M16 6a3 3 0 0 1 0 6M21 19a6 6 0 0 0-4-5.7" /></>, size);
const IconSearch = ({ size }) => svg(<><circle cx="11" cy="11" r="6.5" /><path d="M20 20l-4-4" /></>, size);
const IconMail = ({ size }) => svg(<><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M4 7l8 6 8-6" /></>, size);
const IconMenu = ({ size = 24 }) => svg(<><path d="M4 7h16M4 12h16M4 17h16" /></>, size);
const IconTelegram = ({ size = 20 }) => svg(<path d="M21 5L3 12l5 2 2 5 3-3 4 3 4-14Z" />, size);
const IconSlack = ({ size = 20 }) => svg(<><rect x="9" y="3" width="3" height="9" rx="1.5" /><rect x="12" y="12" width="3" height="9" rx="1.5" /><rect x="3" y="9" width="9" height="3" rx="1.5" /><rect x="12" y="12" width="9" height="3" rx="1.5" /></>, size);

// Brand glyphs (filled, monochrome via currentColor) for footer social links
const BrandTelegram = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" /></svg>
);
const BrandVK = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6.79 7.3H4.05c.13 6.24 3.25 9.99 8.72 9.99h.31v-3.57c2.01.2 3.53 1.67 4.14 3.57h2.84c-.78-2.84-2.83-4.41-4.11-5.01 1.28-.74 3.08-2.54 3.51-4.98h-2.58c-.56 1.98-2.22 3.78-3.8 3.95V7.3H10.5v6.92c-1.6-.4-3.62-2.34-3.71-6.92Z" /></svg>
);

/* ============================ Hooks ============================ */
const useScrolled = (threshold = 8) => {
  const [scrolled, setScrolled] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);
  return scrolled;
};

/* ============================ Shared ============================ */
/* Section index — «§02 / ВОЗМОЖНОСТИ» (DESIGN_SYSTEM §12.4) */
const SectionIndex = ({ n, label }) => (
  <span className="bh-index"><span className="bh-index__n">§{n}</span> / {label}</span>
);

const SectionHead = ({ index, eyebrow, title, lead }) => (
  <div className="bh-head bh-head--center">
    {eyebrow && <SectionIndex n={index} label={eyebrow} />}
    <h2 className="bh-h2">{title}</h2>
    {lead && <p className="bh-head__lead">{lead}</p>}
  </div>
);

const NAV = [
  { href: '#features', label: 'Возможности' },
  { href: '#pricing', label: 'Тарифы' },
  { href: 'https://t.me/infoscale', label: 'Центр поддержки', external: true },
  { href: 'https://infoscale.ru', label: 'О компании', external: true },
];

/* ============================ Brand mark ============================ */
/* S-марка InfoScale. Буква S — контур из JetBrains Mono Medium (500),
   закривлена при разработке: пиксель-в-пиксель с infoscale.ru и никакой
   зависимости от загрузки шрифта. Цвета кружка/буквы задаются CSS-ом
   (.brand-mark / .brand--inverted), один SVG на все варианты. */
const S_MARK_PATH = 'M38.19 55.48Q33.01 55.48 29.94 52.77Q26.86 50.06 26.86 45.3H31.62Q31.62 48.09 33.39 49.67Q35.17 51.26 38.19 51.26Q41.07 51.26 42.78 49.65Q44.48 48.04 44.48 45.35Q44.48 43.34 43.38 41.82Q42.27 40.31 40.26 39.78L35.07 38.39Q31.66 37.43 29.67 34.91Q27.68 32.39 27.68 28.94Q27.68 26.1 28.95 23.97Q30.22 21.83 32.53 20.66Q34.83 19.48 37.86 19.48Q40.93 19.48 43.26 20.66Q45.58 21.83 46.88 23.94Q48.18 26.06 48.18 28.84H43.47Q43.47 26.54 41.91 25.1Q40.35 23.66 37.86 23.66Q35.36 23.66 33.85 25.1Q32.34 26.54 32.34 28.84Q32.34 30.71 33.34 31.98Q34.35 33.26 36.18 33.78L41.5 35.22Q45.1 36.18 47.12 38.9Q49.14 41.61 49.14 45.35Q49.14 48.42 47.79 50.7Q46.45 52.98 43.98 54.23Q41.5 55.48 38.19 55.48Z';

const BrandMark = ({ size = 32 }) => (
  <svg className="brand-mark" viewBox="0 0 76 76" width={size} height={size} aria-hidden="true">
    <circle cx="38" cy="38" r="27" fill="currentColor" />
    <path className="brand-mark__s" d={S_MARK_PATH} />
  </svg>
);

/* ============================ Header ============================ */
const Brand = () => (
  <a className="brand" href="#hero" aria-label="Статус доступности — на главную">
    <BrandMark />
    <span>
      <span className="brand__name">Статус доступности</span>
      <span className="brand__by" style={{ display: 'block' }}>
        от <a href="https://infoscale.ru" target="_blank" rel="noopener noreferrer">ООО «Инфоскейл»</a>
      </span>
    </span>
  </a>
);

const Header = ({ openReg, openLogin }) => {
  const scrolled = useScrolled();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const close = () => setMenuOpen(false);

  return (
    <header className={`site-header ${scrolled ? 'site-header--scrolled' : ''}`}>
      <div className="container">
        <div className="site-header__row">
          <Brand />

          <nav className="nav nav--desktop" aria-label="Основная навигация">
            {NAV.map((i) => (
              <a key={i.href} className="nav__link" href={i.href}
                target={i.external ? '_blank' : undefined} rel={i.external ? 'noopener noreferrer' : undefined}>
                {i.label}
              </a>
            ))}
          </nav>

          <div className="header-actions">
            <div className="header-contacts">
              <span>+7 (495) 128-78-99</span>
              <a href="mailto:support@infoscale.ru">support@infoscale.ru</a>
            </div>
            <button className="btn btn--secondary btn--sm" onClick={openLogin}>Войти</button>
            <button className="btn btn--primary btn--sm" onClick={openReg}>Подключить бесплатно</button>
            <button className="nav-toggle" aria-label="Меню" aria-expanded={menuOpen} onClick={() => setMenuOpen((v) => !v)}>
              <IconMenu />
            </button>
          </div>
        </div>

        <div className={`mobile-menu ${menuOpen ? 'mobile-menu--open' : ''}`}>
          <div className="mobile-menu__inner">
            {NAV.map((i) => (
              <a key={i.href} className="mobile-menu__link" href={i.href} onClick={close}
                target={i.external ? '_blank' : undefined} rel={i.external ? 'noopener noreferrer' : undefined}>
                {i.label}
              </a>
            ))}
            <div className="mobile-menu__contacts">
              <span>+7 (495) 128-78-99</span>
              <a href="mailto:support@infoscale.ru" style={{ color: 'var(--primary)' }}>support@infoscale.ru</a>
            </div>
            <div className="mobile-menu__cta">
              <button className="btn btn--secondary btn--block" onClick={() => { close(); openLogin(); }}>Войти</button>
              <button className="btn btn--primary btn--block" onClick={() => { close(); openReg(); }}>Подключить бесплатно</button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

/* ============================ Hero + dashboard ============================ */
const HeroDashboard = () => (
  <div className="dash" role="img" aria-label="Панель мониторинга: два сайта и AI-бот поддержки работают, один сервис недоступен, аптайм 99,97%">
    <div className="dash__head">
      <span className="dash__head-title">Мои сайты</span>
      <span className="badge badge--ok"><span className="dot dot--ok" /> Под наблюдением</span>
    </div>
    <div className="dash__rows">
      <div className="dash__row">
        <span className="dot dot--ok" />
        <span className="dash__name">mysite.ru</span>
        <span className="dash__uptime">99.98%</span>
        <span className="dash__ms">142 ms</span>
      </div>
      <div className="dash__row">
        <span className="dot dot--ok" />
        <span className="dash__name">shop.mysite.ru</span>
        <span className="dash__uptime">99.95%</span>
        <span className="dash__ms">210 ms</span>
      </div>
      <div className="dash__row">
        <span className="dot dot--ok" />
        <span className="dash__name">AI-бот</span>
        <span className="dash__uptime">ответ ок</span>
        <span className="dash__ms">0.8 s</span>
      </div>
      <div className="dash__row dash__row--down">
        <span className="dot dot--danger" />
        <span className="dash__name">api.mysite.ru</span>
        <span className="dash__down">СБОЙ</span>
        <span className="dash__ms" style={{ color: 'var(--danger)' }}>503</span>
      </div>
    </div>

    <div className="dash__foot">
      <span className="dash__foot-label">Аптайм · 30 дней</span>
      <svg className="dash__spark" width="160" height="40" viewBox="0 0 160 40" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="sk" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#2563eb" stopOpacity=".22" />
            <stop offset="1" stopColor="#2563eb" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d="M0 28 L16 24 L32 26 L48 16 L64 19 L80 11 L96 14 L112 22 L128 9 L144 12 L160 7 V40 H0 Z" fill="url(#sk)" />
        <path d="M0 28 L16 24 L32 26 L48 16 L64 19 L80 11 L96 14 L112 22 L128 9 L144 12 L160 7"
          stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
      <span className="dash__uptime" style={{ fontSize: 15 }}>99.97%</span>
    </div>

    <div className="dash__ssl">
      <IconLock size={18} />
      <span className="dash__ssl-text">
        <span className="dash__ssl-title">SSL · mysite.ru</span>
        <span className="dash__ssl-sub">действует ещё 14 дней</span>
      </span>
    </div>

    <div className="dash__toast">
      <div className="dash__toast-title"><span className="dot dot--danger" /> Сайт недоступен</div>
      <div className="dash__toast-body">api.mysite.ru не отвечает с 14:32. Проверяем повторно каждую минуту.</div>
      <div className="dash__toast-chan">Отправлено в Telegram ✓</div>
    </div>
  </div>
);

const HERO_CHIPS = [
  { icon: <IconClock size={18} />, label: 'Настройка за пару минут' },
  { icon: <IconBell size={18} />, label: 'Уведомления 24/7' },
  { icon: <IconLock size={18} />, label: 'SSL и аптайм под контролем' },
  { icon: <IconGlobe size={18} />, label: 'Сайты, сервисы и API' },
];

const Hero = ({ onCheckSite }) => {
  const [site, setSite] = React.useState('');
  const submit = (e) => { e.preventDefault(); onCheckSite(site.trim()); };

  return (
    <section id="hero" className="hero">
      <div className="bh-gridlines" aria-hidden="true" />
      <span className="bh-reg bh-reg--tl" aria-hidden="true" />
      <span className="bh-reg bh-reg--tr" aria-hidden="true" />
      <div className="container">
        <div className="hero__head">
          <div className="bh-eyebrow-row">
            <span className="bh-mono">Мониторинг сайтов · SSL · Уведомления 24/7</span>
            <a className="badge badge--new" href="#ai-bot">Новое · проверка AI-ботов поддержки →</a>
          </div>
          <h1 className="bh-h1">
            <span className="bh-h1__line">О сбое узнаёте</span>
            <span className="bh-h1__line">
              <span className="bh-h1__seg--volt">вы —</span>{' '}
              <span className="bh-h1__seg--outline">не клиенты</span><span className="bh-cursor" aria-hidden="true" />
            </span>
          </h1>
        </div>
        <div className="hero__grid">
          <div className="hero__content">
            <p className="hero__sub">
              Круглосуточно следим за сайтом, SSL и сервисами. Уведомление в Telegram,
              Slack или на почту — в первую минуту простоя. Бесплатно, без карты.
            </p>

            <form className="domain-form" onSubmit={submit}>
              <input
                className="domain-form__input"
                type="text" inputMode="url" aria-label="Адрес вашего сайта"
                placeholder="Введите адрес сайта — например, mysite.ru"
                value={site} onChange={(e) => setSite(e.target.value)}
              />
              <button type="submit" className="btn btn--primary">Подключить бесплатно</button>
            </form>
            <p className="domain-form__hint">
              Бесплатно, без карты. <a className="link" href="#how">Как это работает →</a>
            </p>

            <div className="hero__chips">
              {HERO_CHIPS.map((c) => (
                <span key={c.label} className="chip">{c.icon}{c.label}</span>
              ))}
            </div>
          </div>

          <div><HeroDashboard /></div>
        </div>
      </div>
    </section>
  );
};

/* ============================ Telemetry strip ============================ */
/* DESIGN_SYSTEM §12.4 — 4 hairline-divided cells, mono key + tabular value.
   Заменяет прежнюю полосу доверия; факт аккредитации Минцифры сохранён в
   ячейке «Статус». Новых цифр не выдумываем. */
const TELEMETRY = [
  { k: 'Проверки', v: 'от 1 раза в минуту' },
  { k: 'Мониторинг', v: '24 · 7 · 365' },
  { k: 'Каналы', v: 'Telegram · Slack · Email' },
  { k: 'Компания', v: 'ООО «Инфоскейл»' },
];

const Telemetry = () => (
  <section className="section--tight" style={{ background: '#fff' }}>
    <div className="container">
      <div className="bh-telemetry">
        {TELEMETRY.map((t) => (
          <div key={t.k} className="bh-tel">
            <div className="bh-tel__k">{t.k}</div>
            <div className="bh-tel__v bh-num">{t.v}</div>
          </div>
        ))}
      </div>
      <div className="bh-telemetry-note">
        <IconShield size={14} />
        Аккредитованная IT-компания · Реестр Минцифры России
      </div>
    </div>
  </section>
);

/* ============================ Features ============================ */
const FEATURES = [
  { icon: <IconGlobe size={26} />, title: 'Доступность сайта', text: 'Проверяем, что сайт открывается и отвечает кодом 200, а не отдаёт ошибку или таймаут.', cta: { label: 'Типы проверок', href: '#checks' } },
  { icon: <IconLock size={26} />, title: 'Проверка SSL-сертификата', text: 'Контролируем валидность сертификата и заранее предупреждаем об истечении срока.' },
  { icon: <IconDns size={26} />, title: 'Срок действия домена', text: 'Следим за датой окончания регистрации домена и заранее предупреждаем, чтобы он не истёк незаметно.' },
  { icon: <IconPing size={26} />, title: 'Ping и доступность хоста', text: 'Проверяем, отвечает ли сервер на сетевом уровне — ловим проблему ещё до отказа сайта.' },
  { icon: <IconClock size={26} />, title: 'Контроль времени отклика', text: 'Если сайт не отвечает в пределах заданного таймаута — считаем это сбоем и сразу уведомляем.' },
  { icon: <IconBell size={26} />, title: 'Мгновенные уведомления', text: 'Сигнал о сбое в Telegram, Slack или на почту — в первую минуту инцидента.', cta: { label: 'Все каналы', href: '#alerts' } },
  { icon: <IconHistory size={26} />, title: 'История инцидентов', text: 'Полный журнал простоев: когда случился, сколько длился и что происходило.' },
  { icon: <IconChart size={26} />, title: 'Отчёты и аналитика', text: 'Наглядные отчёты по аптайму и SLA — для себя, руководства или клиента.' },
];

const Features = () => (
  <section id="features" className="section section--alt">
    <div className="container">
      <SectionHead index="02" eyebrow="Возможности" title="Что под наблюдением"
        lead="Доступность, безопасность и скорость сайта — под постоянным контролем." />
      <div className="grid grid-4">
        {FEATURES.map((f, i) => (
          <div key={f.title} className="card card--hover feat">
            <span className="bh-card-index" aria-hidden="true">{String(i + 1).padStart(2, '0')}</span>
            <span className="feat__icon">{f.icon}</span>
            <h3 className="feat__title">{f.title}</h3>
            <p className="feat__text">{f.text}</p>
            {f.cta && <a className="feat__cta" href={f.cta.href}>{f.cta.label}<IconArrow /></a>}
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ============================ How it works ============================ */
const STEPS = [
  { icon: <IconRocket size={34} />, title: 'Добавьте сайт или сервис', text: 'Укажите адрес — домен, URL или хост. Больше ничего настраивать не нужно.' },
  { icon: <IconSliders size={34} />, title: 'Выберите проверки', text: 'HTTP, SSL, домен или ping и частоту — от одного раза в минуту.' },
  { icon: <IconBell size={34} />, title: 'Получайте уведомления', text: 'Подключите Telegram, Slack или почту. Напишем в первую же минуту сбоя.' },
  { icon: <IconChart size={34} />, title: 'Анализируйте и предотвращайте', text: 'Смотрите историю и отчёты, чтобы проблемы не повторялись.' },
];

const HowItWorks = () => (
  <section id="how" className="section">
    <div className="container">
      <SectionHead index="03" eyebrow="Как это работает" title="Запуск за четыре шага"
        lead="Без интеграции и кода — меньше пяти минут. Справится и не-технический специалист." />
      <div className="steps">
        {STEPS.map((s, i) => (
          <div key={s.title} className="step">
            <span className="step__icon">{s.icon}<span className="step__num">{String(i + 1).padStart(2, '0')}</span></span>
            <h3 className="step__title">{s.title}</h3>
            <p className="step__text">{s.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ============================ Check types ============================ */
const CHECKS = [
  { icon: <IconGlobe size={24} />, title: 'HTTP / HTTPS', text: 'Сайт открывается и возвращает корректный ответ (200 OK), а не 5xx или таймаут.' },
  { icon: <IconLock size={24} />, title: 'SSL-сертификат', text: 'Сертификат валиден, без ошибок и не истекает в ближайшие дни.' },
  { icon: <IconDns size={24} />, title: 'Домен', text: 'Регистрация домена не истекает в ближайшие дни — предупредим заранее.' },
  { icon: <IconPing size={24} />, title: 'Ping', text: 'Хост доступен по сети и отвечает в пределах нормального времени.' },
  { icon: <IconRobots size={24} />, title: 'robots.txt', text: 'Файл доступен поисковикам и не закрывает весь сайт от Google и Яндекса — например, после выкладки со стенда.' },
  { icon: <IconBot size={24} />, title: 'AI-бот поддержки', text: 'Бот отвечает на контрольный вопрос, и ответ соответствует вашей инструкции.', cta: { label: 'Подробнее', href: '#ai-bot' } },
];

const CheckTypes = () => (
  <section id="checks" className="section section--alt">
    <div className="container">
      <SectionHead index="04" eyebrow="Типы проверок" title="Что именно мы проверяем"
        lead="Один сервис закрывает основные точки отказа — от главной страницы до домена и сети." />
      <div className="grid grid-2" style={{ maxWidth: 920, margin: '0 auto' }}>
        {CHECKS.map((c) => (
          <div key={c.title} className="card card--hover check">
            <span className="check__icon">{c.icon}</span>
            <span>
              <h3 className="check__title">{c.title}</h3>
              <p className="check__text">{c.text}</p>
              {c.cta && <a className="feat__cta" href={c.cta.href}>{c.cta.label}<IconArrow /></a>}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ============================ AI-bot checks ============================ */
const AIBOT_POINTS = [
  { title: 'Подключите бота по API', text: 'Любой JSON API или OpenAI-совместимый. Ключ хранится в зашифрованном виде.' },
  { title: 'Задайте вопрос и инструкцию', text: 'Например: «Как вернуть товар?» — и что должно быть в правильном ответе.' },
  { title: 'Мы спрашиваем бота по расписанию', text: 'От раза в час до раза в сутки. Ответ проверяет AI по вашей инструкции.' },
  { title: 'Алерт — только по делу', text: 'Бот не ответил, вернул ошибку или ответил не по инструкции. Перед алертом перепроверяем.' },
];

const AIBot = () => (
  <section id="ai-bot" className="section">
    <div className="container">
      <SectionHead index="05" eyebrow="AI-боты" title="Ваш AI-бот отвечает правильно?"
        lead="Бот поддержки может «сломаться» тихо: отвечать ерундой или молчать. StatusBot регулярно задаёт ему контрольный вопрос и сообщит, если что-то пошло не так." />
      <div className="grid grid-2" style={{ alignItems: 'center', gap: 40 }}>
        <div className="grid grid-2" style={{ gap: 14 }}>
          {AIBOT_POINTS.map((p, i) => (
            <div key={p.title} className="card">
              <span className="bh-card-index" aria-hidden="true">{String(i + 1).padStart(2, '0')}</span>
              <h3 className="feat__title">{p.title}</h3>
              <p className="feat__text">{p.text}</p>
            </div>
          ))}
        </div>
        <div>
          <div className="bh-live" style={{ marginBottom: 14 }}>
            <span className="bh-live__dot" /> Проверка AI-бота · пример
          </div>
          <div className="bh-term">
            <div className="bh-term__line">
              <span className="bh-term__dot bh-term__dot--down" />
              <span className="bh-term__k">[ALERT]</span> AI-бот поддержки — ответ не по инструкции
            </div>
            <div className="bh-term__body">Вопрос: «Как вернуть товар?» · ответ: «Позвоните оператору» · срок возврата не назван</div>
            <div className="bh-term__meta">// отправлено в Telegram · 09:00</div>
          </div>
          <div className="bh-term">
            <div className="bh-term__line">
              <span className="bh-term__dot bh-term__dot--up" />
              <span className="bh-term__k">[OK]</span> AI-бот поддержки — снова отвечает правильно
            </div>
            <div className="bh-term__body">«Вернуть товар можно в течение 14 дней в личном кабинете»</div>
            <div className="bh-term__meta">// отправлено в Telegram · 11:00</div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

/* ============================ Use cases ============================ */
const USECASES = [
  { icon: <IconBriefcase size={26} />, title: 'Бизнес и сайты-визитки', text: 'Сайт — это заявки и продажи. Узнавайте о простое раньше, чем клиент уйдёт к конкуренту.' },
  { icon: <IconCart size={26} />, title: 'Интернет-магазины', text: 'Недоступная корзина — упущенная выручка. Контролируйте доступность и скорость в часы пик.' },
  { icon: <IconServer size={26} />, title: 'IT-команды и админы', text: 'Десятки сайтов и сервисов на одном экране. Меньше ручных проверок — быстрее реакция.' },
  { icon: <IconCode size={26} />, title: 'Разработка и SaaS', text: 'Мониторьте продакшн и эндпоинты. Узнавайте о деградации до того, как прилетит тикет.' },
];

const UseCases = () => (
  <section className="section">
    <div className="container">
      <SectionHead index="06" eyebrow="Кому подходит" title="Один сервис — разные задачи"
        lead="От лендинга до распределённой инфраструктуры." />
      <div className="grid grid-4">
        {USECASES.map((u) => (
          <div key={u.title} className="card card--hover">
            <span className="usecase__icon">{u.icon}</span>
            <h3 className="usecase__title">{u.title}</h3>
            <p className="usecase__text">{u.text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* ============================ Notifications ============================ */
const CHANNELS = [
  { icon: <IconTelegram />, name: 'Telegram', sub: 'в личку или чат' },
  { icon: <IconMail />, name: 'Email', sub: 'письмо с деталями' },
  { icon: <IconSlack />, name: 'Slack', sub: 'в рабочий канал' },
  { icon: <IconBell size={18} />, name: 'Личный кабинет', sub: 'лента инцидентов' },
];

const Notifications = () => (
  <section id="alerts" className="section bh-flagship">
    <span className="bh-reg bh-reg--tl" aria-hidden="true" />
    <span className="bh-reg bh-reg--br" aria-hidden="true" />
    <div className="container">
      <SectionHead index="07" eyebrow="Уведомления" title="Узнаёте первыми — там, где удобно"
        lead="Подключите нужные каналы и получайте только важные оповещения. Список каналов постоянно расширяется." />
      <div className="grid grid-2" style={{ alignItems: 'center', gap: 40 }}>
        <div className="grid grid-2" style={{ gap: 14 }}>
          {CHANNELS.map((c) => (
            <div key={c.name} className="chan">
              <span className="chan__icon">{c.icon}</span>
              <span>
                <span className="chan__name" style={{ display: 'block' }}>{c.name}</span>
                <span className="chan__sub">{c.sub}</span>
              </span>
            </div>
          ))}
        </div>
        <div>
          <div className="bh-live" style={{ marginBottom: 14 }}>
            <span className="bh-live__dot" /> Лента инцидентов · live
          </div>
          <div className="bh-term">
            <div className="bh-term__line">
              <span className="bh-term__dot bh-term__dot--down" />
              <span className="bh-term__k">[ALERT]</span> api.mysite.ru — сайт недоступен
            </div>
            <div className="bh-term__body">Не отвечает с 14:32 · код 503 · SSL: OK</div>
            <div className="bh-term__meta">// отправлено в Telegram · 14:32</div>
          </div>
          <div className="bh-term">
            <div className="bh-term__line">
              <span className="bh-term__dot bh-term__dot--up" />
              <span className="bh-term__k">[OK]</span> api.mysite.ru — снова работает
            </div>
            <div className="bh-term__body">Доступен с 14:46 · простой длился 14 минут</div>
            <div className="bh-term__meta">// отправлено в Telegram · 14:46</div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

/* ============================ Business value ============================ */
const VALUES = [
  { icon: <IconInbox size={22} />, title: 'Заявки не приходят', text: 'Пока сайт лежит, форма не отправляется и оплата не проходит. Мониторинг сокращает время простоя.' },
  { icon: <IconUsers size={22} />, title: 'Клиенты уходят к конкурентам', text: 'Не дозвонившись на сайт, человек открывает следующую вкладку. Быстрая реакция удерживает его.' },
  { icon: <IconSearch size={22} />, title: 'Поисковики замечают нестабильность', text: 'Регулярные падения могут влиять на ранжирование. Стабильный аптайм работает на вас.' },
  { icon: <IconBell size={22} />, title: 'Команда узнаёт вовремя', text: 'Не из жалоб клиентов, а из уведомления — и чинит проблему, пока она маленькая.' },
];

const COMPARE_BAD = ['О сбое узнаёте из жалоб клиентов', 'Реакция — часы', 'Об истёкшем SSL узнаёте по ошибке в браузере', 'Нет доказательств аптайма', 'Ночью и в выходные — без контроля'];
const COMPARE_GOOD = ['Уведомление в первую минуту', 'Реакция — минуты', 'Предупреждение об SSL заранее', 'Отчёты и история инцидентов', 'Контроль 24/7 автоматически'];

const BusinessValue = () => (
  <section className="section">
    <div className="container">
      <SectionHead index="08" eyebrow="Зачем это бизнесу" title="Сколько стоит простой"
        lead="Несколько фактов о том, что теряется, пока сайт недоступен." />
      <div className="grid grid-4" style={{ marginBottom: 36 }}>
        {VALUES.map((v) => (
          <div key={v.title} className="card card--hover">
            <span className="usecase__icon">{v.icon}</span>
            <h3 className="feat__title" style={{ fontSize: 17 }}>{v.title}</h3>
            <p className="feat__text" style={{ marginTop: 8 }}>{v.text}</p>
          </div>
        ))}
      </div>
      <div className="compare">
        <div className="compare__col compare__col--bad">
          <div className="compare__h"><span className="dot dot--danger" /> Без мониторинга</div>
          {COMPARE_BAD.map((t) => (
            <div key={t} className="compare__item"><span style={{ color: 'var(--muted)' }}><IconArrow size={16} /></span>{t}</div>
          ))}
        </div>
        <div className="compare__col compare__col--good">
          <div className="compare__h"><span className="dot dot--ok" /> Со «Статусом доступности»</div>
          {COMPARE_GOOD.map((t) => (
            <div key={t} className="compare__item"><span style={{ color: 'var(--ok)' }}><IconCheck size={18} /></span>{t}</div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

/* ============================ Pricing ============================ */
const FREE_FEATURES = ['Проверки HTTP, SSL, домена, ping и robots.txt', 'Проверка AI-бота поддержки', 'Уведомления в Telegram, Slack и на почту', 'Частота проверок — от 1 раза в минуту', 'История инцидентов и отчёты об аптайме', 'Мониторинг нескольких сайтов и сервисов'];
const ENT_FEATURES = ['Индивидуальные лимиты и условия', 'Приоритетная поддержка', 'Помощь с настройкой мониторинга', 'Документы для бухгалтерии'];

const Pricing = ({ openReg }) => (
  <section id="pricing" className="section section--alt">
    <div className="container">
      <SectionHead index="09" eyebrow="Тарифы" title="Простые и честные условия"
        lead="Начните прямо сейчас — без карты и скрытых платежей." />
      <div className="pricing__banner"><span className="pill pill--accent">Пока сервис полностью бесплатен — доступны все возможности и типы проверок</span></div>
      <div className="price-grid">
        <div className="price-card price-card--featured">
          <span className="price-card__ribbon">Сейчас доступно всё</span>
          <div className="price-card__name">Старт</div>
          <div className="price-card__who">Для сайтов, магазинов и команд</div>
          <div className="price-card__price">
            <span className="price-card__amount">Бесплатно</span>
          </div>
          <div className="price-card__features">
            {FREE_FEATURES.map((f) => (
              <div key={f} className="price-card__feature"><IconCheck size={18} />{f}</div>
            ))}
          </div>
          <div className="price-card__cta">
            <button className="btn btn--primary btn--lg btn--block" onClick={openReg}>Начать бесплатно</button>
          </div>
        </div>

        <div className="price-card">
          <div className="price-card__name">Корпоративный</div>
          <div className="price-card__who">Для крупного бизнеса с особыми требованиями</div>
          <div className="price-card__price">
            <span className="price-card__amount" style={{ fontSize: 28 }}>Индивидуально</span>
          </div>
          <div className="price-card__features">
            {ENT_FEATURES.map((f) => (
              <div key={f} className="price-card__feature"><IconCheck size={18} />{f}</div>
            ))}
          </div>
          <div className="price-card__cta">
            <a className="btn btn--secondary btn--lg btn--block" href="mailto:support@infoscale.ru?subject=Корпоративный%20мониторинг">Связаться с нами</a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

/* ============================ FAQ ============================ */
const FAQ = [
  ['Что именно проверяет сервис?', 'Доступность сайта по HTTP/HTTPS, валидность и срок SSL-сертификата, срок действия домена, доступность хоста по ping, robots.txt — и работу AI-бота поддержки. Частоту проверок вы задаёте сами.'],
  ['Как работает проверка AI-бота?', 'Вы подключаете бота по API и задаёте контрольный вопрос с короткой инструкцией, каким должен быть правильный ответ. По расписанию мы задаём вопрос, а AI сверяет ответ с инструкцией. Если бот не ответил, вернул ошибку или ответил не по инструкции — после перепроверки пришлём уведомление с фрагментом ответа.'],
  ['Как быстро я узнаю о сбое?', 'В первую же минуту после обнаружения: мы проверяем сайт с заданным интервалом — от одного раза в минуту — и сразу отправляем уведомление.'],
  ['Можно ли мониторить несколько сайтов?', 'Да. Можно отслеживать несколько сайтов и сервисов одновременно — все они видны на одном экране.'],
  ['Проверяете ли вы SSL-сертификаты?', 'Да. Контролируем валидность и заранее напоминаем об истечении срока, чтобы сертификат не «протух» незаметно.'],
  ['Можно отслеживать не только сайт, но и домен или сервер?', 'Да. Кроме HTTP-проверок есть контроль срока действия домена и ping хоста — это помогает поймать проблему на сетевом уровне.'],
  ['Нужна ли техническая настройка?', 'Нет. Достаточно указать адрес и выбрать проверки. Ничего устанавливать на сайт или сервер не нужно.'],
  ['Есть ли бесплатный тариф?', 'Сейчас сервис полностью бесплатен — доступны все возможности и типы проверок.'],
  ['Можно ли получать уведомления в Telegram?', 'Да: Telegram, Slack и email. Список каналов постоянно расширяется.'],
  ['Чем это лучше ручной проверки сайта?', 'Сервис работает 24/7, в том числе ночью и в выходные, проверяет каждую минуту и хранит историю — человек так не сможет и узнаёт обычно последним.'],
  ['Подходит ли сервис для интернет-магазина?', 'Да, это один из основных сценариев: вы первыми узнаёте, если корзина или оплата перестали работать.'],
];

const Faq = () => (
  <section id="faq" className="section">
    <div className="container">
      <SectionHead index="10" eyebrow="Вопросы и ответы" title="Частые вопросы" />
      <div className="faq">
        {FAQ.map(([q, a], i) => (
          <details className="faq__item" key={q} open={i === 0}>
            <summary>{q}<span className="faq__chevron"><IconChevron /></span></summary>
            <div className="faq__answer">{a}</div>
          </details>
        ))}
      </div>
      <p className="lead" style={{ textAlign: 'center', marginTop: 32, fontSize: 15 }}>
        Не нашли ответ? <a className="link" href="https://t.me/infoscale" target="_blank" rel="noopener noreferrer">Напишите в Центр поддержки</a> — поможем с настройкой.
      </p>
    </div>
  </section>
);

/* ============================ Final CTA ============================ */
const FinalCta = ({ openReg }) => (
  <section className="section bh-finale">
    <span className="bh-reg bh-reg--tl" aria-hidden="true" />
    <span className="bh-reg bh-reg--tr" aria-hidden="true" />
    <span className="bh-reg bh-reg--bl" aria-hidden="true" />
    <span className="bh-reg bh-reg--br" aria-hidden="true" />
    <div className="container" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
      <h2 className="bh-finale__h">Подключите мониторинг за минуты</h2>
      <p className="bh-finale__lead">
        Бесплатно, без карты и сложных настроек. Узнавайте о сбоях раньше клиентов уже сегодня.
      </p>
      <div className="bh-finale__note">// ответ в первую минуту сбоя</div>
      <div style={{ marginTop: 26 }}>
        <button className="btn btn--white btn--lg" onClick={openReg}>Подключить бесплатно</button>
      </div>
      <div className="bh-finale__chips">
        <span className="chip"><IconCheck size={16} /> Полностью бесплатно</span>
        <span className="chip"><IconCheck size={16} /> Настройка за 3 минуты</span>
        <span className="chip"><IconCheck size={16} /> Поддержка на русском</span>
      </div>
    </div>
  </section>
);

/* ============================ Footer ============================ */
const SOCIAL = [
  { href: 'https://t.me/infoscale', icon: <BrandTelegram />, label: 'Telegram' },
  { href: 'https://vk.com/infoscale', icon: <BrandVK />, label: 'VK' },
  { href: 'https://habr.com/ru/users/InfoScale/', img: iconHabr, label: 'Habr' },
];

const Footer = () => (
  <footer className="site-footer">
    <div className="container">
      <div className="footer__grid">
        <div>
          <div className="brand brand--inverted" style={{ marginBottom: 8 }}>
            <BrandMark />
            <span className="footer__brand-name">Статус доступности</span>
          </div>
          <div className="footer__legal">
            ООО «Инфоскейл»<br />
            ИНН 9701245975 · КПП 770101001<br />
            ОГРН 1237700265934<br />
            Тел.: +7 (495) 128-78-99<br />
            <a href="mailto:support@infoscale.ru">support@infoscale.ru</a>
          </div>
          <div className="social">
            {SOCIAL.map((s) => (
              <a key={s.label} className="social__link" href={s.href} target="_blank" rel="noopener noreferrer" title={s.label} aria-label={s.label}>
                {s.icon || <img src={s.img} alt={s.label} width="18" height="18" loading="lazy" decoding="async" />}
              </a>
            ))}
          </div>
          <div className="bh-footer-status"><span className="bh-live__dot" /> Все системы в норме</div>
        </div>

        <div>
          <div className="footer__title">Продукт</div>
          <a className="footer__link" href="#features">Возможности</a>
          <a className="footer__link" href="#checks">Типы проверок</a>
          <a className="footer__link" href="#pricing">Тарифы</a>
          <a className="footer__link" href="#faq">Вопросы и ответы</a>
        </div>

        <div>
          <div className="footer__title">Поддержка</div>
          <a className="footer__link" href="https://t.me/infoscale" target="_blank" rel="noopener noreferrer">Центр поддержки</a>
          <a className="footer__link" href="https://infoscale.ru" target="_blank" rel="noopener noreferrer">О компании</a>
          <a className="footer__link" href="/privacy">Конфиденциальность</a>
        </div>

        <div>
          <div className="footer__title">Время работы</div>
          <div className="footer__legal" style={{ marginTop: 0 }}>
            Мониторинг — круглосуточно<br />
            Поддержка — 24/7<br />
            Без выходных и праздников
          </div>
        </div>
      </div>
      <div className="footer__bottom">© 2026 «Статус доступности» от ООО «Инфоскейл». Все права защищены.</div>
    </div>
  </footer>
);

/* ============================ Page ============================ */
const HomePage = () => {
  const [regOpen, setRegOpen] = React.useState(false);
  const [loginOpen, setLoginOpen] = React.useState(false);
  const [prefillSite, setPrefillSite] = React.useState('');

  const openReg = React.useCallback(() => setRegOpen(true), []);
  const openLogin = React.useCallback(() => setLoginOpen(true), []);
  const checkSite = React.useCallback((s) => { setPrefillSite(s); setRegOpen(true); }, []);

  // The sticky mobile CTA duplicates the hero's own "Подключить бесплатно" while
  // the hero is on screen (PIN-173). Reveal it only once the hero — and its CTA
  // — has scrolled away.
  const [stickyCta, setStickyCta] = React.useState(false);
  React.useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero || typeof IntersectionObserver === 'undefined') return undefined;
    const obs = new IntersectionObserver(
      ([entry]) => setStickyCta(!entry.isIntersecting),
      { rootMargin: '0px 0px -45% 0px' },
    );
    obs.observe(hero);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="bold-home">
      <Header openReg={openReg} openLogin={openLogin} />
      <main>
        <Hero onCheckSite={checkSite} />
        <Telemetry />
        <Features />
        <HowItWorks />
        <CheckTypes />
        <AIBot />
        <UseCases />
        <Notifications />
        <BusinessValue />
        <Pricing openReg={openReg} />
        <Faq />
        <FinalCta openReg={openReg} />
      </main>
      <Footer />

      <div className={`mobile-cta${stickyCta ? ' mobile-cta--visible' : ''}`} aria-hidden={!stickyCta}>
        <button className="btn btn--primary btn--block btn--lg" onClick={openReg} tabIndex={stickyCta ? 0 : -1}>Подключить бесплатно</button>
      </div>

      {(regOpen || loginOpen) && (
        <Suspense fallback={null}>
          <AuthModals
            regOpen={regOpen} loginOpen={loginOpen}
            setRegOpen={setRegOpen} setLoginOpen={setLoginOpen}
            prefillSite={prefillSite}
          />
        </Suspense>
      )}
    </div>
  );
};

export default HomePage;
